export const faqData = [
    {
        id: "01",
        question:
            "Can we help with hardware selection and setup?",
        answer: [
            {
                type: "paragraph",
                content: "We take complete responsibility for the selection of suitable hardware, including PCB components and industrial IoT sensors. We handle the physical assembly of all devices before developing the custom software layer, ensuring perfect synergy between your hardware and the IoT solutions company's code."
            },
           
        ],
    },
    {
        id: "02",
        question:
            " Can edge computing be utilized for my project?",
        answer: [
            {
                type: "paragraph",
                content: "Yes, edge computing use-cases have increased significantly with the evolution of computing power on minimal chip-sets. Depending on your requirements, we can implement complex solutions such as machine learning models on edge TPU chips using frameworks like AWS IoT Greengrass for local processing and autonomous operation."
            },
           
        ],
    },
    {
        id: "03",
        question:
            "Which cloud platforms do we use to manage IoT data?",
        answer: [
            {
                type: "paragraph",
                content: "We build hardware-agnostic solutions that integrate with the world’s leading cloud ecosystems. Depending on your scaling needs and existing infrastructure, we can deploy and manage your IoTs using AWS IoT Core, Azure IoT Hub, or Google Cloud IoT. This ensures your cloud services for managing IoT data are secure, scalable, and industry-standard."
            },
           
        ],
    },
    {
        id: "04",
        question:
            "Are custom solutions possible for my choice of sensors and chip-sets? ",
        answer: [
            {
                type: "paragraph",
                content: "Our expertise with coding and extensive understanding of field essentials enables us to present you with customized solutions which can go all the way down to precise chip-set level control using assembly language. Whether you are using Raspberry Pi, Arduino, or a custom microcontroller, we ensure your firmware is optimized for your specific hardware."
            },
           
        ],
    },
    {
        id: "05",
        question:
            "Are IoT applications operable on all devices?",
        answer: [
            {
                type: "paragraph",
                content: "We build enterprise-grade IoT software solutions compatible with all required devices and tailor-made to the expectations of our clients. Your dashboard will be accessible via web browsers, mobile apps, or desktop interfaces, providing unified device management across your entire operation."
            },
           
        ],
    },
    {
        id: "06",
        question:
            "How do we handle data security and compliance?",
        answer: [
            {
                type: "paragraph",
                content: "We implement a multi-layered security strategy that includes access control, encrypted data transmission, and firmware signing to protect against hacking. Our development process follows industry best practices to ensure your IoT monitoring systems remain compliant with relevant data protection regulations."
            },
           
        ],
    },

];